import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-home-acx-cta',
  templateUrl: './home-acx-cta.component.html',
  styleUrls: ['./home-acx-cta.component.scss'],
})
export class HomeAcxCtaComponent {
  @Output() access = new EventEmitter<void>();

  onAccess(): void {
    this.access.emit();
  }
}
